module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.lazyVal.name),
      callback: function($$v) {
        _vm.$set(_vm.lazyVal, "name", $$v)
      },
      expression: "lazyVal.name"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "name": "pnc_type",
      "value": _vm.lazyVal,
      "single-line": "",
      "messages": _vm.pncTypeMessages
    }
  }, [_c('v-expansion-panels', [_c('isrs-pnc-type-card', {
    attrs: {
      "type": "locationId",
      "itemKey": "0",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Location",
      "text": "Explore hundreds of Locations ready to connect with this Parcel Number Container! For more information visit the Unique technical manual.",
      "query": _vm.handleQueryLocations,
      "value": _vm.location,
      "fields": ['id', 'code']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "ownerId",
      "itemKey": "1",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Owner",
      "text": "Restrict this Parcel Number Container to the following owner.",
      "query": _vm.handleQueryOwners,
      "value": _vm.owner,
      "fields": ['id', 'code']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "customerId",
      "itemKey": "2",
      "itemText": "customerName1",
      "itemValue": "customerId",
      "headline": "Customer",
      "text": "Only these customers can use this Parcel Number Container.",
      "query": _vm.handleQueryCustomers,
      "value": _vm.customer,
      "fields": ['customerName1']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "outboundOwnerId",
      "itemKey": "3",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Outbound Owner",
      "text": "Select the owner for which the outbound parcel number container shall be created.",
      "query": _vm.handleQueryOwners,
      "value": _vm.outboundOwner,
      "fields": ['id', 'code']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "inboundOwnerId",
      "itemKey": "4",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Inbound Owner",
      "text": "Select the owner for which the inbound parcel number container shall be created.",
      "query": _vm.handleQueryOwners,
      "value": _vm.inboundOwner,
      "fields": ['id', 'code']
    },
    on: {
      "input": _vm.updateType
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePNC()
      }
    }
  }, [_vm._v("Save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-0140ef0b"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsParcelNumberContainer.vue
// module id = 915
// module chunks = 1